import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { Container, Grid, Paper } from '@material-ui/core'
import { ArrowBackRounded as BackIcon } from '@material-ui/icons'

import api from '../../services/api'
import TextField from '../../components/atoms/inputs/textfield'
import Button from '../../components/atoms/inputs/button'
import Typography from '../../components/atoms/display/typography'
import CircularProgress from '../../components/atoms/feedback/circularProgress'
import Snackbar from '../../components/atoms/feedback/snackbar'
import Alert from '../../components/atoms/feedback/alert'
import SwitchLanguage from '../../components/molecules/switchs/language'
import SwitchTheme from '../../components/molecules/switchs/theme'

const PasswordRecovery = ({ t }) => {
  const [done, setDone] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({})
  const [formError, setFormError] = useState({})
  const [snackbar, setSnackbar] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')

  const inputHandle = (event) => {
    setForm((form) => ({
      ...form,
      [event?.target?.name]: event?.target?.value,
    }))
  }

  const submit = () => {
    setFormError({})
    setLoading(true)
    api({
      method: 'POST',
      url: '/security/user/password-reset',
      data: {
        email: form.email,
        slug: process.env.REACT_APP_SLUG,
      },
    })
      .then((response) => {
        setLoading(false)
        setDone(true)
      })
      .catch((error) => {
        setLoading(false)
        let data = error.response.data
        data.message?.map((el) => {
          if (el.key === 'e-mail') {
            return setFormError((formError) => ({
              ...formError,
              email: el.value,
            }))
          } else {
            return setFormError((formError) => ({
              ...formError,
              [el.key]: el.value,
            }))
          }
        })
      })
  }

  const renderDone = () => {
    return (
      <>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Alert severity="success" icon={false}>
            {t('alerts.passwordRecoverSuccess')}
          </Alert>
        </Grid>
      </>
    )
  }

  const renderForm = () => {
    return (
      <>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Alert severity="info" icon={false}>
            {t('alerts.passwordRecoverInfo')}
          </Alert>
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <TextField
            id="field-email"
            label={t('fields.email.label')}
            placeholder={t('fields.email.placeHolder')}
            type="text"
            color="primary"
            variant="outlined"
            name="email"
            value={form.email ? form.email : ''}
            onChange={inputHandle}
            error={formError?.email ? true : false}
            helperText={
              formError?.email && t(`fields.email.errors.${formError.email}`)
            }
            shrink={true}
            fullWidth={true}
          />
        </Grid>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <Button
            size="large"
            variant="contained"
            color="primary"
            fullWidth={true}
            onClick={() => submit()}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={25} color="inherit" />
            ) : (
              t('buttons.passwordRecover')
            )}
          </Button>
        </Grid>
      </>
    )
  }

  return (
    <>
      <Container>
        <div style={{ height: 84 }} />
        <Grid container direction="row" spacing={2} justify="center">
          <Grid item xl={4} lg={4} md={6} sm={8} xs={12}>
            <Paper elevation={12}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: 120,
                  backgroundColor: '#f6f6f6',
                }}
              >
                <img src="/logo.png" alt="Porto" width="180" height="56" />
              </div>
              <div style={{ padding: 50 }}>
                <Grid container direction="row" spacing={2}>
                  <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Button
                      size="large"
                      color="primary"
                      startIcon={<BackIcon color="primary" />}
                      component={RouterLink}
                      to="/signin"
                    >
                      {t('buttons.back')}
                    </Button>
                  </Grid>
                  {done ? renderDone() : renderForm()}
                </Grid>
              </div>
            </Paper>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: 25,
              }}
            >
              <Typography variant="body1">
                © {new Date().getFullYear()} {t('app.copyright')}
              </Typography>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: 5,
              }}
            >
              <SwitchLanguage />
              <div style={{ width: 10 }} />
              <SwitchTheme />
            </div>
          </Grid>
        </Grid>
      </Container>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={snackbar}
        onClose={() => setSnackbar(false)}
        autoHideDuration={3000}
        message={snackbarMessage}
      />
    </>
  )
}

export default withTranslation()(PasswordRecovery)
